export default "<div id=\"distributor\"></div>\n";